import BaseModule from "./BaseModule";
import Factory from "../libs/Factory";
import {requireElement} from "../libs/Helpers";

export default class Calculator extends BaseModule {
    declare el: HTMLDivElement;
    private elOutput: HTMLOutputElement;
    private fuelOutput: HTMLOutputElement;
    private calculatedOutput: HTMLOutputElement;
    private mileageInput: HTMLInputElement;
    private fuelConsumptionInput: HTMLInputElement;
    private fuelPriceInput: HTMLInputElement;
    private elPriceInput: HTMLInputElement;
    private readonly elConsumption: number;

    constructor(el: HTMLElement, factory: Factory) {
        super(el, factory, 'Calculator');
        this.elOutput = requireElement<HTMLOutputElement>(el, "output[for='el-cost']");
        this.fuelOutput = requireElement<HTMLOutputElement>(el, "output[for='fuel-cost']");
        this.calculatedOutput = requireElement<HTMLOutputElement>(el, "output[for='calculated']");
        this.mileageInput = requireElement<HTMLInputElement>(el, "input[id='mileage']");
        this.fuelPriceInput = requireElement<HTMLInputElement>(el, "input[id='fuel-price']");
        this.fuelConsumptionInput = requireElement<HTMLInputElement>(el, "input[id='fuel-consumption']");
        this.elPriceInput = requireElement<HTMLInputElement>(el, "input[id='el-price']");
        // TODO: make configurable
        this.elConsumption = 66.9/(263/1.60934); // 66.9 kWh / 263 km (battery/range [km/1.60934])

        this.updateOutputs();

        [   this.mileageInput,
            this.fuelConsumptionInput,
            this.fuelPriceInput,
            this.elPriceInput
        ].forEach((field) => {
            if(!field){ return; }

            const output = document.querySelector<HTMLOutputElement>(`output[for=${field.id}]`);
            if(!output){ return; }

            output.textContent = field.value;
            field.addEventListener("input", () => {
                output.textContent = Number(field.value).toLocaleString("en-GB", { minimumFractionDigits: 1, maximumFractionDigits: 3 });
                this.updateOutputs();
            });
        });
    }

    updateOutputs() {
        // fuel: (miles/year) / (mpg/4.546) * (price/liter)
        const fuel = Number(this.mileageInput.value) / (Number(this.fuelConsumptionInput.value) / 4.546) * Number(this.fuelPriceInput.value);
        this.fuelOutput.textContent = fuel.toLocaleString("en-GB", { maximumFractionDigits: 0 });
        // electric: (miles/year) * (battery/range [km/1.60934]) * (price/kWh)
        const electric = Number(this.mileageInput.value) * this.elConsumption * Number(this.elPriceInput.value);
        this.elOutput.textContent = electric.toLocaleString("en-GB", { maximumFractionDigits: 0 });

        const savings = fuel - electric;
        this.calculatedOutput.textContent = savings < 0 ? 'No fuel savings' : '£' + savings.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}